module.exports = __webpack_public_path__ + "static/media/phone.a2d37e54.svg";